import React from 'react';

const HeadingText = ({children}) => {
    return <p className="grow text-7xl text-white px-8">{children}</p>;
}

export default HeadingText;